<template>
	<article class="app-plan-card">
		<a class="app-plan-card__link" :href="prescription.url">
			<p class="app-plan-card__programm">
				{{ prescription.program_title }}
			</p>
			<h3 class="app-plan-card__title">
				{{ prescription.item_title }}
			</h3>
			<div class="app-plan-card__bottom">
				<p v-if="!recommended" class="app-plan-card__message" :class="messageClass">
					{{ currentDays(prescription) }} {{ daysLeft(prescription) }}
				</p>
				<div class="app-plan-card__progress">
					<div class="app-plan-card__scale">
						<div class="app-plan-card__bar" :style="'width: ' + prescription.result + '%;'"></div>
					</div>
					<p class="app-plan-card__value">
						{{ prescription.result }}%
					</p>
				</div>
			</div>
		</a>
	</article>
</template>

<script>
export default {
	name: "PlanPreview",

	props: {
		prescription: Object,
		currentCompany: {
			type: String,
			default: ''
		},
		recommended: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			loading: true,
			isContinue: false,
			messageClass: ''
		};
	},

	methods: {
		daysLeft(p) {
			if (p.how_many_days_left == 1 && p.result != 100) {
				this.isContinue = true;
				this.messageClass = 'app-plan-card__message--danger'
				return this.$t('deadlines.last_day');
			} else if (p.how_many_days_left == 0 && p.result != 100) {
				this.isContinue = false;
				this.messageClass = 'app-plan-card__message--danger';
				return this.$t('deadlines.late');
			} else if (p.result == 100) {
				this.isContinue = false;
				this.messageClass = 'app-plan-card__message--success';
				return this.$t('deadlines.finished');
			} else {
				this.isContinue = true;
				let days = +p.how_many_days_left;
				this.messageClass = 'app-plan-card__message--success';
				return this.$t('days', days);
			}
		},

		currentDays(p) {
			if (p.how_many_days_left == 0 || p.how_many_days_left == 1) {
				return this.$t('assignment');
			} else if (p.result == 100) {
				return this.$t('assignment');
			} else {
				return this.$t('deadlines.current');
			}
		},

		plan_card_progress_class(result) {
			if (result > 75) {
				return "plan-item__progress--high";
			} else if (result > 50) {
				return "plan-item__progress--upper-middle";
			} else if (result > 25) {
				return "plan-item__progress--lower-middle";
			} else {
				return "plan-item__progress--low";
			}
		},
	}
};
</script>
